module.exports = __webpack_public_path__ + "static/media/WhatsApp_Image_2021-05-15_at_11_27_57_AM.087696ab.jpeg";